/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Tab_UsedInputs */

const en_admin_invite_codes_tab_used = /** @type {(inputs: Admin_Invite_Codes_Tab_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Used`)
};

/**
* | output |
* | --- |
* | "Used" |
*
* @param {Admin_Invite_Codes_Tab_UsedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_tab_used = /** @type {((inputs?: Admin_Invite_Codes_Tab_UsedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Tab_UsedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_invite_codes_tab_used(inputs)
});
export { admin_invite_codes_tab_used as "admin.invite_codes.tab_used" }